import React, { useEffect, useRef } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { BASE } from "../../basedata/constants";
import { useTheme } from "@mui/material/styles";

import "./Layout.sass";
import Header from "../Header/Header";

interface LayoutProps {
  children: React.ReactNode;
  headerVariant?: 'default' | 'dark' | 'primary';
  noPadding?: boolean;
  noFooter?: boolean;
  scrollToContent?: boolean;
}

const Layout = ({
  children,
  headerVariant = 'default',
  noPadding = false,
  noFooter = false,
  scrollToContent = false,
}: LayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const backgroundImage = isMobile ? "none" : `url(${BASE.company.background_image})`;
  const footerLogo = isMobile ? BASE.company.bepassMobileLogo : BASE.company.bepassLogo;

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollToContent && contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [scrollToContent]);

  const renderFooter = () => {
    if (noFooter) return null;

    return (
      <Box className="layout-footer">
        <img
          src={footerLogo}
          alt="Bepass Logo"
          className="layout-footer-logo"
        />
      </Box>
    );
  };

  return (
    <Box
      className="layout-wrapper"
      style={{
        backgroundImage,
      }}
    >
      <Header variant={headerVariant} />
      <Box className="layout-content">
        <Box
          ref={contentRef}
          className={`onboarding-content-wrapper ${noPadding ? 'no-padding' : ''}`}
        >
          {children}
        </Box>
      </Box>
      {renderFooter()}
    </Box>
  );
};

export default Layout;
